import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}

export const Styles = styled.div<IProps>`
  width: 100%;
  .ant-select-selector {
    min-height: 40px !important;
    background: ${(props) =>
      props.background ? props.background + " !important" : ""};
    .org-infor {
      color: ${(props) => (props.color ? props.color + " !important" : "")};
    }
  }
`;
